export default __webpack_public_path__ + "static/media/Willow Bark.1883844f.PNG";